/**
 * UGC Video Reel
 * - Videos are always muted (no sound toggle)
 * - Muted autoplay for videos >= 60% on screen (if enabled + no reduced motion)
 * - Off-screen videos pause
 * - Play button shows when a video isn't playing (reduced motion / autoplay off)
 * - Custom element, so theme-editor re-renders re-initialize automatically
 */
(function () {
  if (customElements.get('ugc-video-reel')) return;

  class UgcVideoReel extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.ugc-reel__card'));
      if (!this.cards.length) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true' && !reduceMotion;

      this.cards.forEach((card) => {
        var video = card.querySelector('[data-video]');
        if (!video) return;

        video.muted = true;
        video.addEventListener('playing', () => card.classList.add('is-playing'));
        video.addEventListener('pause', () => card.classList.remove('is-playing'));

        var play = card.querySelector('[data-play]');
        if (play) {
          play.addEventListener('click', (event) => {
            event.stopPropagation();
            this.play(video);
          });
        }
      });

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            var video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              if (this.autoplay) this.play(video);
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.6] }
      );
      this.cards.forEach((card) => {
        var video = card.querySelector('[data-video]');
        if (video) this.observer.observe(video);
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    play(video) {
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
    }
  }

  customElements.define('ugc-video-reel', UgcVideoReel);
})();
